"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Globals = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _component = _interopRequireDefault(require("./component"));

// NOTE: we don't use redux here as we want a react-independent implementation--yes, we can use
// redux without React, but we don't need all the complexity of redux.
var Globals =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Globals, _Component);

  function Globals() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Globals);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Globals)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'Globals');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onNavigate", null);
    return _this;
  }

  (0, _createClass2.default)(Globals, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(Globals.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            // The current path. This path is changed whenever the URL changes in the
            // browser bar, including when the user hits the back or forward buttons.
            name: 'path',
            component: 'TextField'
          }, {
            // A temporary prop used to hold the redirectPath until the redirect is initiated by the
            // UI. This value should be cleared after the redirect is initiated so that back-to-back
            // redirects to the same route are considered unique, e.g. if / routes to /somepage and
            // then the user hits back.
            name: 'redirectPath',
            component: 'TextField'
          }, {
            name: 'snackbarMessage',
            component: 'TextField'
          }, {
            name: 'appId',
            component: 'TextField'
          }, {
            name: 'confirmation',
            component: 'TextField'
          }, {
            name: 'searchString',
            component: 'TextField'
          }, {
            name: 'redirectAfterLogin',
            component: 'TextField'
          }, {
            name: 'reCAPTCHASiteKey',
            component: 'TextField'
          }, {
            name: 'route',
            component: 'Field'
          }]
        }
      });
    }
  }, {
    key: "redirect",
    value: function redirect(path) {
      this.set({
        redirectPath: path
      });
    }
  }, {
    key: "displaySnackbar",
    value: function displaySnackbar(message) {
      this.set({
        snackbarMessage: message
      });
    }
  }, {
    key: "setOnNavigate",
    value: function setOnNavigate(onNavigate) {
      this._onNavigate = onNavigate;
    } // A hook for ReactRouter's back/forward event handling. This is a bit ugly, but this is what
    // ReactRouter provides us.

  }, {
    key: "onNavigate",
    value: function onNavigate(message, callback) {
      if (this._onNavigate) {
        // We don't care about message as we populate is elsewhere
        this._onNavigate(callback);
      }
    }
  }, {
    key: "displayConfirmation",
    value: function displayConfirmation(_ref) {
      var title = _ref.title,
          text = _ref.text,
          callback = _ref.callback,
          alert = _ref.alert;
      this.set({
        confirmation: {
          title: title,
          text: text,
          callback: callback,
          alert: alert
        }
      });
    }
  }, {
    key: "displayAlert",
    value: function displayAlert(_ref2) {
      var title = _ref2.title,
          text = _ref2.text,
          callback = _ref2.callback;
      this.displayConfirmation({
        title: title,
        text: text,
        callback: callback,
        alert: true
      });
    }
  }]);
  return Globals;
}(_component.default);

exports.Globals = Globals;

var _default = new Globals();

exports.default = _default;